import React from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import './HourlyPackageModal.css';

const HourlyPackageModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="hourly-modal-overlay">
      <div className="hourly-modal-content">
        <button className="hourly-modal-close" onClick={onClose}>
          &times;
        </button>
        <div className="hourly-modal-header">
          <button className="hourly-modal-back" onClick={onClose}>
            &#8592;
          </button>
          <h2 className="hourly-modal-title">Hourly Photography Packages</h2>
        </div>

        <div className="hourly-modal-body">
          {/* Standard Package */}
          <div 
            className="hourly-package-card"
            onClick={() => navigate('/hourly-standard')}
          >
            <div className="package-image-container">
              <img 
                src={`${process.env.PUBLIC_URL}/asset/landing-page/hourly-standard.png`} 
                alt="Standard" 
              />
            </div>
            <div className="package-details">
              <h3>Standard</h3>
              <p>Balanced, Efficient, Professional</p>
            </div>
            <div className="package-arrow">&#8250;</div>
          </div>

          {/* Premium Package */}
          <div 
            className="hourly-package-card"
            onClick={() => navigate('/hourly-premium')}
          >
            <div className="package-image-container">
              <img 
                src={`${process.env.PUBLIC_URL}/asset/landing-page/hourly-premium.png`} 
                alt="Premium" 
              />
            </div>
            <div className="package-details">
              <h3>Premium</h3>
              <p>Elevated, Detailed, Production Ready</p>
            </div>
            <div className="package-arrow">&#8250;</div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default HourlyPackageModal;
